import { type StripeSubscriptionSummary } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

export interface SetAutoRenewRequest {
    enabled: boolean;
}

export interface SetAutoRenewResult {
    subscription: StripeSubscriptionSummary;
}

export const useSetAutoRenew = requestBuilder.mutation<
    SetAutoRenewResult,
    SetAutoRenewRequest
>({
    endpoint: '/api/billing/subscription/auto-renew',
    method: 'POST',
});
